import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=974b033e&scoped=true&lang=pug&"
import script from "./DropZone.vue?vue&type=script&lang=ts&"
export * from "./DropZone.vue?vue&type=script&lang=ts&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=974b033e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974b033e",
  null
  
)

export default component.exports